export default __webpack_public_path__ + "static/fonts/HelveticaNeue-Roman.b12caad.woff2";